import React, { useCallback } from 'react';
import { MobileSelect } from '../../../SelectComponents/Select';
import { isMultiSelectOptions } from '../../../utils';
export const SortSelect = _ref => {
  let {
    options,
    selectedOption,
    onSelectedOptionChange
  } = _ref;
  const handleChange = useCallback(newOptionOrOptions => {
    if (newOptionOrOptions && !isMultiSelectOptions(newOptionOrOptions)) {
      onSelectedOptionChange({
        option: newOptionOrOptions,
        location: 'mobile'
      });
    }
  }, [onSelectedOptionChange]);
  return /*#__PURE__*/React.createElement(MobileSelect, {
    testId: "mobile-sort-picker-select",
    options: options,
    selectedOptions: [selectedOption],
    status: "default",
    onSelectionChange: handleChange
  });
};